<template>
  <Layout>
    <div class="row">
      <div class="col-12">
        <div class="
            mb-2
            d-flex
            align-items-center
            justify-content-between
          ">
          <h4 class="mb-0 font-size-18">{{ $t(title) }}</h4>
          <div class="page-title-right">
            <div class="col-md text-right">
              <b-button v-b-modal.modal-lg variant="primary" @click="closeOptionModal">
                <b>Nouveau</b>
              </b-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-6 text-right">
            <b-modal id="modal-lg" v-model="showModal" size="lg" centered :title="modalTitle" title-class="font-18"
              hide-footer>
              <form @submit.prevent="onSubmit" v-if="!updating">
                <div class="row">
                  <div class="col">
                    <label>{{ $t("pages.metadata.heading") }} </label>
                    <input type="text" v-model.trim="label" class="form-control" required />
                  </div>
                </div>
                <div class="row mt-4 mb-12">
                  <div class="col">
                    <label>{{ $t("pages.metadata.type") }} </label>
                    <select class="form-control" v-model.trim="type">
                      <option v-for="(type, index) in types" :key="index" :value="type.value">
                        {{ $t(`pages.metadata.types.${type.type}`) }}
                      </option>
                    </select>
                  </div>
                </div>
                <div v-if="isList" class="row mt-4">
                  <div class="col">
                    <label for="">Options</label>
                    <a href="#" @click="showOptionModal = true" class="float-right text-success">
                      + {{ $t("pages.metadata.option.new_option") }}
                    </a>
                    <multiselect v-model="option" :options="options" :multiple="true"
                      :tage-placeholder="$t('pages.documentType.search')" :placeholder="$t('pages.documentType.tag')"
                      label="label" track-by="id" :taggable="true"></multiselect>
                    <div class="col-2">
                      <b-modal id="option-modal-lg" v-model="showOptionModal" size="lg"
                        :title="$t('pages.metadata.option.add')" title-class="font-18" hide-footer>
                        <form @submit.prevent="addOption">
                          <div class="row">
                            <div class="col">
                              <label>{{
                              $t("pages.documentType.heading")
                              }}</label>
                              <input type="text" v-model.trim="form.option.label" class="form-control" required />
                            </div>
                          </div>
                          <hr />
                          <div class="row">
                            <div class="col">
                              <button type="button" class="btn btn-outline-light btn-block" @click="closeOptionModal"
                                data-dismiss="modal">
                                {{ $t("pages.documentType.cancel") }}
                              </button>
                            </div>
                            <div class="col">
                              <button type="submit" v-if="this.isLoading === false" class="btn btn-primary btn-block">
                                {{ $t("pages.documentType.save") }}
                              </button>
                              <button class="btn btn-primary btn-block" type="button" v-else disabled>
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                {{ $t("pages.documentType.saving") }}
                              </button>
                            </div>
                          </div>
                        </form>
                      </b-modal>
                    </div>
                  </div>
                </div>
                <div class="custom-control custom-switch mt-4">
                  <div class="col mt-3 text-left">
                    <input type="checkbox" v-model="required" @click="toggle" class="custom-control-input"
                      id="customSwitch1" />
                    <label class="custom-control-label" for="customSwitch1">{{ $t("pages.metadata.required") }}</label>
                  </div>
                </div>
                <hr />
                <div class="row">
                  <div class="col-12">
                    <button type="submit" v-if="this.isLoading === false" class="btn btn-primary mr-2">
                      {{ $t("pages.metadata.save") }}
                    </button>
                    <button class="btn btn-primary mr-2" type="button" v-else disabled>
                      <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                      {{ $t("pages.metadata.saving") }}
                    </button>
                    <button type="button" class="btn btn-light" @click="showModal = false" data-dismiss="modal">
                      {{ $t("pages.metadata.cancel") }}
                    </button>
                  </div>
                </div>
              </form>
              <form @submit.prevent="onSubmit" v-else>
                <div class="row mt-4">
                  <div class="col">
                    <label>{{ $t("pages.metadata.heading") }} </label>
                    <input type="text" v-model.trim="selectedMetadata.label" class="form-control" required />
                  </div>
                </div>
                <div class="row mt-4 mb-12">
                  <div class="col">
                    <label>{{ $t("pages.metadata.type") }} </label>
                    <select class="form-control" v-model.trim="selectedMetadata.type"
                      @change="change(selectedMetadata)">
                      <option v-for="(type, index) in types" :key="index" :value="type.value">
                        {{ $t(`pages.metadata.types.${type.type}`) }}
                      </option>
                    </select>
                  </div>
                </div>
                <div v-if="selectedMetadata.type === 'list'" class="row mt-4">
                  <div class="col">
                    <label for="">Options</label>
                    <a href="#" @click="showOptionModal = true" class="float-right text-success">
                      + {{ $t("pages.metadata.option.new_option") }}
                    </a>
                    <multiselect v-model="metaOptions" :options="options" :multiple="true"
                      :tage-placeholder="$t('pages.documentType.search')" :placeholder="$t('pages.documentType.tag')"
                      label="label" track-by="id" :taggable="true" @input="checkOptionChange"></multiselect>
                    <div class="col-2">
                      <b-modal id="option-modal-lg" v-model="showOptionModal" size="lg"
                        :title="$t('pages.metadata.option.add')" title-class="font-18" hide-footer>
                        <form @submit.prevent="addOption">
                          <div class="row">
                            <div class="col">
                              <label>{{
                              $t("pages.documentType.heading")
                              }}</label>
                              <input type="text" v-model.trim="form.option.label" class="form-control" required />
                            </div>
                          </div>
                          <hr />
                          <div class="row">
                            <div class="col">
                              <button type="button" class="btn btn-outline-light btn-block" @click="closeOptionModal"
                                data-dismiss="modal">
                                {{ $t("pages.documentType.cancel") }}
                              </button>
                            </div>
                            <div class="col">
                              <button type="submit" v-if="this.isLoading === false" class="btn btn-primary btn-block">
                                {{ $t("pages.documentType.save") }}
                              </button>
                              <button class="btn btn-primary btn-block" type="button" v-else disabled>
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                {{ $t("pages.documentType.saving") }}
                              </button>
                            </div>
                          </div>
                        </form>
                      </b-modal>
                    </div>
                  </div>
                </div>
                <div class="custom-control custom-switch mt-4">
                  <div class="col mt-3 text-left">
                    <input type="checkbox" v-model="selectedMetadata.required" @click="toggle"
                      class="custom-control-input" id="customSwitch1" />
                    <label class="custom-control-label" for="customSwitch1">{{ $t("pages.metadata.required") }}</label>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12 text-left">
                    <hr />
                    <button type="submit" v-if="this.isLoading === false" class="btn btn-primary mr-2">
                      {{ $t("pages.metadata.save") }}
                    </button>
                    <button class="btn btn-primary mr-2" type="button" v-else disabled>
                      <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    </button>
                    <button type="button" class="btn btn-light" @click="showModal = false" data-dismiss="modal">
                      {{ $t("pages.metadata.cancel") }}
                    </button>
                  </div>
                </div>
              </form>
            </b-modal>
          </div>
        </div>
        <div class="q-pa-md">
          <div v-if="isLoading">
            <b-skeleton-table :rows="8" :columns="4"></b-skeleton-table>
          </div>
          <div class="row" v-else-if="metadatas.length > 0">
            <div class="col-12 col-md-6 d-block d-lg-none" v-for="(metadata, index) in pageOfItems" :key="index" :value="metadata">
              <b-card class="border">
                <b-dropdown class="card-drop float-right" variant="white" right toggle-class="p-0">
                  <template v-slot:button-content>
                    <i class="mdi mdi-dots-vertical font-size-18"></i>
                  </template>

                  <b-dropdown-item @click="updateMetadataModal(metadata)">
                    {{ $t("pages.metadata.edit") }}
                  </b-dropdown-item>

                  <b-dropdown-item @click.prevent="onDelete(metadata.id)">
                    {{ $t("pages.metadata.delete") }}
                  </b-dropdown-item>
                </b-dropdown>
                
                <b-card-title>
                  {{ metadata.label }}
                </b-card-title>

                <b-card-text>{{ $t("pages.metadata.type") }}: {{ $t(`pages.metadata.types.${metadata.type}`) }}
                  <div v-if="metadata.required">
                    {{ $t("pages.metadata.Onrequired") }}: 
                    <span class="badge badge-success">
                      {{ $t("pages.metadata.yes") }}
                    </span>
                  </div>
                  <div v-else>
                    {{ $t("pages.metadata.Onrequired") }}: 
                    <span class="badge badge-warning">
                      {{ $t("pages.metadata.non") }}
                    </span>
                  </div>
                </b-card-text>

                <b-card-text class="small text-muted">{{ $d(new Date(metadata.created_at), "long") }}</b-card-text>
              </b-card>
            </div>
            <div class="col-12 d-none d-lg-table">
              <table class="table table-hover mt-2">
                <thead class="thead-light">
                  <tr>
                    <th class="text-left">
                      {{ $t("pages.metadata.heading") }}
                    </th>
                    <th class="text-left">{{ $t("pages.metadata.type") }}</th>
                    <th class="text-left">
                      {{ $t("pages.metadata.Onrequired") }}
                    </th>
                    <th class="text-left">{{ $t("pages.metadata.date") }}</th>
                    <th class="text-left"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(metadata, index) in pageOfItems" :key="index" :value="metadata">
                    <td>{{ metadata.label }}</td>
                    <td>
                      {{ $t(`pages.metadata.types.${metadata.type}`) }}
                    </td>
                    <td>
                      <div v-if="metadata.required">
                        <span class="badge badge-success">
                          {{ $t("pages.metadata.yes") }}
                        </span>
                      </div>
                      <div v-else>
                        <span class="badge badge-warning">
                          {{ $t("pages.metadata.non") }}
                        </span>
                      </div>
                    </td>
                    <td>
                      {{ $d(new Date(metadata.created_at), "long") }}
                    </td>
                    <td class="text-center">
                      <b-dropdown class="card-drop" variant="white" right toggle-class="p-0">
                        <template v-slot:button-content>
                          <i class="mdi mdi-dots-horizontal font-size-18"></i>
                        </template>

                        <b-dropdown-item @click="updateMetadataModal(metadata)">
                          {{ $t("pages.metadata.edit") }}
                        </b-dropdown-item>

                        <b-dropdown-item @click.prevent="onDelete(metadata.id)">
                          {{ $t("pages.metadata.delete") }}
                        </b-dropdown-item>
                      </b-dropdown>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="text-center empty-state-container" v-else>
            <div class="row">
              <div class="col-md-3 mx-auto">
                <lottie-animation ref="anim" :animationData="require('@/assets/json/empty-state.json')" :loop="true" />
              </div>
            </div>
            <h4 class="text-center">{{ $t("pages.metadata.inactiveMeta") }}</h4>
            <p class="mt-2">{{ $t("pages.metadata.userMeta") }}</p>
          </div>
          <!-- <div class="empty-state text-center" v-else>
            <i class="bx bxs-file mb-3"></i>
            <h4 class="text-center">{{ $t("pages.metadata.inactiveMeta") }}</h4>
            <p class="mt-2">
              {{ $t("pages.metadata.userMeta") }}
            </p>                 
          </div> -->
        </div>

        <div class="row mb-4">
          <div class="col-md-12">
            <div class="text-center">
              <jw-pagination :pageSize="pageSize" :items="metadatas" @changePage="onChangePage" :labels="labels"
                class="text-center"></jw-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>


<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import Multiselect from "vue-multiselect";
import { mapActions, mapState } from "vuex";
import LottieAnimation from "lottie-web-vue";

export default {
  page: {
    title: "Métadonnées",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Multiselect,
    LottieAnimation
  },
  data() {
    return {
      isLoading: false,
      isDeleting: false,
      showModal: false,
      showOptionModal: false,
      updating: false,
      selectedMetadata: {},
      title: "pages.metadata.metadata",
      types: [
        {
          type: "number",
          value: "number",
          text: this.$t("pages.metadata.types.number"),
        },
        {
          type: "string",
          value: "string",
          text: this.$t("pages.metadata.types.string"),
        },
        {
          type: "text",
          value: "text",
          text: this.$t("pages.metadata.types.text"),
        },
        {
          type: "date",
          value: "date",
          text: this.$t("pages.metadata.types.date"),
        },
        {
          type: "boolean",
          value: "boolean",
          text: this.$t("pages.metadata.types.boolean"),
        },
        {
          type: "list",
          value: "list",
          text: this.$t("pages.metadata.types.list"),
        },
        {
          type: "file",
          value: "file",
          text: this.$t("pages.metadata.types.file"),
        },
      ],

      labels: {
        first: "<<",
        last: ">>",
        next: ">",
        previous: "<",
      },
      form: {
        option: {
          label: "",
        },
      },
      bool: false,
      pageOfItems: [],
      pageSize: 8,
      label: "",
      type: "",
      required: false,
      isList: false,
      option: [],
      metadataOptions: [],
      currentMetadata: {},
      metaOptions: [],
      gettingMetadataOptions: false
    };
  },
  methods: {
    ...mapActions([
      "getMetadata",
      "createMetadata",
      "deleteMetadata",
      "updateMetadata",
    ]),
    change(metadata) {
      this.updateMetadataModal(metadata);
    },
    closeModal() {
      this.showModal = false;
      this.showOptionModal = false;
      this.forms = {
        id: null,
        label: "",
        type: "",
        required: false,
      };
      this.updating = false;
      this.selectedMetadata = {
        id: null,
        label: "",
        type: "",
        required: false,
      };
    },
    closeOptionModal() {
      this.showOptionModal = false;
    },
    async getOtpionsOfMetadata(metadata) {
      await this.$store
        .dispatch("getMetadataOptions", metadata.id)
        .then((response) => {
          this.metadataOptions = response.data;
          this.currentMetadata = metadata;

          if (this.metaOptions.length === 0) {
            this.metaOptions = this.metadataOptions;
            this.gettingMetadataOptions = true;
          }
        });
    },
    async updateMetadataEmptyOption(metadata) {
      this.showModal = true;
      this.updating = true;

      if (this.currentMetadata !== metadata) {
        this.metaOptions = [];
      }
      if (metadata.type === "list") {
        this.selectedMetadata = {
          id: metadata.id,
          label: metadata.label,
          type: metadata.type,
          required: metadata.required,
          options: JSON.stringify(this.metaOptions),
        };
      }
    },
    async updateMetadataModal(metadata) {
      this.showModal = true;
      this.updating = true;

      if (this.currentMetadata !== metadata) {
        this.metaOptions = [];
      }
      if (metadata.type === "list") {
        await this.getOtpionsOfMetadata(metadata);
        this.selectedMetadata = {
          id: metadata.id,
          label: metadata.label,
          type: metadata.type,
          required: metadata.required,
          options: JSON.stringify(this.metaOptions),
        };
      } else {
        this.selectedMetadata = {
          id: metadata.id,
          label: metadata.label,
          type: metadata.type,
          required: metadata.required,
        };
      }
    },
    onSubmit() {
      this.isLoading = true;
      if (this.updating) {
        if (this.$can("update", "metadata")) {
          this.updateMetadata(this.selectedMetadata)
            .then((response) => {
              if (response.status === 200) {
                this.isLoading = false;
                this.$toasted.success(
                  this.$t("pages.metadata.actions.updated")
                );
                this.closeModal();
              }
            })
            .catch((error) => {
              if (error.response.status === 422) {
                this.isLoading = false;
                this.$toasted.error(this.$t("pages.metadata.actions.fillin"));
              } else {
                this.isLoading = false;
                this.$toasted.error(this.$t("pages.unauthorized.server_error"));
              }
            });
        } else {
          this.isLoading = false;
          this.$toasted.error(this.$t("pages.unauthorized.error_0"));
        }
      } else {
        if (this.$can("create", "metadata")) {
          let formData = new FormData();
          formData.append("label", this.label);
          formData.append("type", this.type);
          formData.append("required", this.required);
          if (this.type === "list") {
            formData.append("options", JSON.stringify(this.option));
          }
          this.createMetadata(formData)
            .then((response) => {
              if (response.status === 201) {
                this.isLoading = false;
                this.$toasted.success(
                  this.$t("pages.metadata.actions.created")
                );
                this.closeModal();
              }
            })
            .catch((error) => {
              if (error.response.status === 422) {
                this.isLoading = false;
                this.$toasted.error(this.$t("pages.metadata.actions.exists"));
              } else {
                this.isLoading = false;
                this.$toasted.error(this.$t("pages.unauthorized.error_0"));
              }
            });
        } else {
          this.isLoading = false;
          this.$toasted.error(this.$t("pages.unauthorized.forbidden_1"));
        }
      }
    },
    onDelete(id) {
      if (this.$can("delete", "metadata")) {
        this.isDeleting = true;
        this.$swal({
          text: `Etes-vous sûr de vouloir supprimer cette metadonnée ?`,
          type: "warning",
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Supprimer",
        }).then((result) => {
          if (result.value) {
            this.deleteMetadata(id)
              .then((response) => {
                if (response.status === 200) {
                  this.isDeleting = false;
                  this.$swal(
                    "Supprimé!",
                    "La metadonnée supprimée avec succès.",
                    "success"
                  );
                }
              })
              .catch((error) => {
                if (error.response.status === 500) {
                  this.isLoading = false;
                  this.$toasted.error(
                    "Impossible de supprimer cette metadonée, car elle possede déjà un type de document...",
                    {
                      duration: 3000,
                      position: "top-center",
                    }
                  );
                }
              });
          }
        });
      } else {
        this.isLoading = false;
        this.$toasted.error(this.$t("pages.unauthorized.forbidden_1"));
      }
    },
    addOption() {
      let data = new FormData();
      data.append("label", this.form.option.label);
      this.$store.dispatch("addOption", data).then(() => {
        this.closeOptionModal();
      });
    },
    onChangePage(pageOfItems) {
      this.pageOfItems = pageOfItems;
    },
    toggle: function () {
      this.required = !this.required;
    },
    resetModal() {
      this.forms = "";
    },
    checkOptionChange() {
      if (this.metaOptions.length === 0) {
        this.metaOptions = [];
        this.updateMetadataEmptyOption(this.currentMetadata);
      } else {
        this.updateMetadataModal(this.currentMetadata);
        this.currentMetadata = {};
      }
    },
  },
  computed: {
    ...mapState({
      metadatas: (state) => state.metadata.metadatas,
    }),
    modalTitle() {
      return this.updating
        ? this.$t("pages.metadata.edit")
        : this.$t("pages.metadata.add");
    },
    options: function () {
      return this.$store.state.metadata.options;
    },
  },

  watch: {
    type: function () {
      if (this.type === "list") {
        this.isList = true;
      }
    },
  },

  created() {
    if (this.$can("list", "metadata")) {
      this.isLoading = true;

      this.getMetadata().then((loaded) => {
        if (loaded) {
          this.isLoading = false;
        } else {
          this.isLoading = false;
        }
      });

      this.$store.dispatch("getOptions").then(() => {
      });
    }
  },
};
</script>
<style lang="scss" scoped>
.table-row {
  cursor: pointer;

  .card-drop {
    visibility: hidden;
  }

  &:hover {
    & .card-drop {
      visibility: visible;
      align-self: center;
    }
  }
}
</style>


